import React, {useContext} from 'react'
import Image from 'next/image';
import { s3Static } from '../../utils/constants';
import { motion } from 'framer-motion';
import Link from 'next/link'
import { LocationContext } from '../../context/LocationContext';
import { UserContext } from '../../context/UserContext';

export const ServiceSection = () => {
    const { countryCd, locality } = useContext(LocationContext)

    const { requestCategorySettings } = useContext(UserContext)
    
  return (
    <div className='container max-w-6xl mx-auto my-20'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-10 space-y-5 px-2'>
            <div className='flex relative items-center bg-linear-to-br from-white to-gray-200 rounded-full h-32 mt-5 text-center'>                
                <motion.div className='absolute right-5 -bottom-0'
                    whileInView={{
                        scale: 1.1,
                        y: -8,                         
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}
                >
                    <Image 
                        height={150} 
                        width={140} 
                        src={s3Static + "3D/3d-aircon-technician-minimized.png"} 
                        alt="Aircon Servicing Singapore"
                        style={{width: '140px', height: '150px'}}
                    />
                </motion.div>
                <div className='p-5 absolute'>
                    {countryCd === "sg" ?
                        <Link href={`/sg/aircon-servicing-singapore`} prefetch={false}>
                                <h3 className='pr-40'><strong>Aircon servicing</strong> for your home or office</h3>
                        </Link>
                        :
                        <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Aircon Services")}`} prefetch={false}>
                                <h3 className='pr-40'><strong>Aircon servicing</strong> for your home or office</h3>
                        </Link>
                    }
                </div>              
            </div> 
            <div className='flex relative items-center bg-linear-to-br from-white to-gray-200 rounded-full h-32 mt-5 text-center'>            
                <motion.div className='absolute left-10 -bottom-0'
                    whileInView={{
                        scale: 1.1, 
                        y: -7,                        
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>                            
                        <Image 
                            height={145} 
                            width={110} 
                            src={s3Static + "3D/part-time-helper-3d-color-minimized.png"} 
                            alt="Part time helper Singapore"
                            style={{width: '120px', height: '150px'}}
                        />
                </motion.div>
                <div className='p-5 absolute'>
                    {countryCd === "sg" ?
                        <Link href={`/sg/part-time-cleaner-singapore`} prefetch={false}>
                                <h3 className='pl-40'><strong>Part-time helper</strong> to help you focus on what&apos;s important to you</h3>
                        </Link>
                        :
                        <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Domestic Services")}`} prefetch={false}>
                                <h3 className='pl-40'>Domestic helper to help you focus on what&apos;s important to you</h3>
                        </Link>
                    }
                </div>           
            </div> 
            <div className='flex relative items-center bg-linear-to-br from-white to-gray-200 rounded-full h-32 mt-5 text-center'>                
                <motion.div className='absolute right-10 -bottom-0'
                    whileInView={{
                        scale: 1.1,
                        y: -8,                         
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>                            
                        <Image 
                            height={159} 
                            width={120} 
                            src={s3Static + "3D/3d-female-trainer-minimized.png"} 
                            alt="Personal Trainer Singapore"
                            style={{width: '110px', height: '140px'}}
                        />                                
                </motion.div>
                <div className='p-5 absolute'>
                    {(countryCd === "sg" || countryCd === "us") ?
                        <Link href={`/${countryCd}/personal-trainer`} prefetch={false}>
                                <h3 className='pr-40'>Get a <strong>personal trainer</strong> to manage your fitness goals</h3>
                        </Link>
                        :
                        <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Fitness Trainer")}`} prefetch={false}>
                                <h3 className='pr-40'>Get a <strong>personal trainer</strong> to manage your fitness goals</h3>
                        </Link>
                    }
                </div>              
            </div>            
            <div className='flex relative items-center bg-linear-to-br from-white to-gray-200 rounded-full h-32 mt-5 text-center'>                
                <motion.div className='absolute left-10 -bottom-0'
                    whileInView={{
                        scale: 1.1,  
                        y: -10,                       
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>
                    <Image 
                        height={150} 
                        width={95} 
                        src={s3Static + "3D/nail-artist-with-tools-minified.png"} 
                        alt="Beauty Services Singapore"
                        style={{width: '100px', height: '140px'}}
                    />
                </motion.div>
                <div className='p-5 absolute'>
                    <Link href={`/services/${countryCd}?requestType=Beauty%20Services`}>
                            <h3 className='pl-32'>Get pampered by an expert <strong>salon professional</strong></h3>
                    </Link>
                </div>              
            </div> 
            <div className='flex relative items-center space-x-5 bg-linear-to-br from-white to-gray-200 rounded-full h-32 text-center'>                
                <motion.div className='absolute right-10 -bottom-0'
                    whileInView={{
                        scale: 1.1,  
                        y: -8,                       
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>
                    <Image 
                        height={135} 
                        width={100} 
                        src={s3Static + "3D/handyman-with-tools-3d-minimized.png"} 
                        alt="Handyman Singapore"
                        style={{width: '100px', height: '135px'}}
                    />
                </motion.div>
                <div className='p-5 absolute'>
                    {countryCd === "sg" ?
                        <Link href={`/${countryCd}/handyman-singapore-services`} prefetch={false}>
                                <h3 className='pr-40'>Plumbing, electrical.. fix anything at home by a <strong>handyman</strong></h3>
                        </Link>
                        :
                        <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Handyman Services")}`} prefetch={false}>
                                <h3 className='pr-40'>Plumbing, electrical.. fix anything at home by a <strong>handyman</strong></h3>
                        </Link>
                    }
                </div>              
            </div>   
            <div className='flex relative items-center space-x-5 bg-linear-to-tr from-white to-gray-200 rounded-full  h-32 text-center'>                
                <motion.div className='absolute left-10 -bottom-0'
                    whileInView={{
                        scale: 1.1,  
                        y: -8,                       
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>                            
                        <Image 
                            height={186} 
                            width={130} 
                            src={s3Static + "3D/property-agent-amber-suit-minified.png"} 
                            alt="Property Agent Singapore"
                            style={{width: '120px', height: '140px'}}
                        />
                </motion.div>
                <div className='p-5 absolute'>
                    {countryCd === "sg" ?
                        <Link href={`/${countryCd}/property-agent`} prefetch={false}>
                                <h3 className='pl-40'><strong>Property agent</strong> to help you find a house for rent or purchase</h3>
                        </Link>
                        :
                        <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Housing")}`} prefetch={false}>
                                <h3 className='pl-40'><strong>Property agent</strong> to help you find a house for rent or purchase</h3>
                        </Link>
                    }
                </div>              
            </div>
            <div className='flex relative items-center space-x-5 bg-linear-to-br from-white to-gray-200 rounded-full h-32 text-center'>                
                <motion.div className='absolute right-10 -bottom-0'
                    whileInView={{
                        scale: 1.1,   
                        y: -7,                      
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>
                        <Image 
                            height={145} 
                            width={95} 
                            src={s3Static + "3D/financial-adviser-minified.png"} 
                            alt="Financial Advisor Singapore"
                            style={{width: '100px', height: '140px'}}
                        />
                </motion.div>
                <div className='p-5 absolute'>
                    {countryCd === "sg" ?
                        <Link href={`/${countryCd}/financial-adviser-singapore`}>
                                <h3 className='pr-40'>Plan your investment and insurance with a <strong>financial advisor</strong></h3>
                        </Link>
                        :
                        <Link href={`/services/${countryCd}?requestType=${encodeURIComponent("Financial")}`} prefetch={false}>
                                <h3 className='pr-40'>Plan your investment and insurance with a <strong>financial advisor</strong></h3>
                        </Link>
                    }
                </div>              
            </div>
            <div className='flex relative items-center bg-linear-to-tr from-white to-gray-200 rounded-full  h-32 text-center'>            
                <motion.div className='absolute left-10 -bottom-0'
                    whileInView={{
                        scale: 1.1,
                        y: -9,                         
                        transition: {duration:0.5}
                    }}
                    viewport={{ margin: "-40% 0% -50% 0%"}}>
                    <Image 
                        height={167} 
                        width={120} 
                        src={s3Static + "3D/female-interior-designer-minified.png"} 
                        alt="Interior Designer"
                        style={{width: '110px', height: '140px'}}
                    />
                </motion.div>
                <div className='p-5 absolute'>
                    <Link href={`/services/${countryCd}?requestType=Interior%20Designing`}>
                            <h3 className='pl-40'>Make your house a home with an <strong>interior designer</strong></h3>
                    </Link>
                </div>           
            </div>
        </div>
    </div>    
  )
}
